<template>
   <va-layout-manager :desktop-sidebar-width="0" :desktop-minibar-width="0" :desktop-topbar-height="user!=null  ? 50 : 0" :mobile-sidebar-width="0"
      :mobile-minibar-width="0" :mobile-topbar-height="user!=null ? 50 : 0" :rtl="false">
      <va-bars v-if="user!=null">
         <va-topbar theme="default" style="min-height:50px; overflow: visible !important;">
            <div slot="left">

               <va-dropdown>
                  <div slot="trigger">
                     <va-button round>
                        <va-icon type="bars" color=""> </va-icon>
                     </va-button>
                  </div>
                  <li>
                     <router-link :to="'/'">Home</router-link>
                  </li>
                  <li>
                     <router-link :to="'/contacts'">Contacts</router-link>
                  </li>
                  <li>
                     <router-link :to="'/provinces'">Provinces</router-link>
                  </li>
                  <li>
                     <router-link :to="'/about'">About</router-link>
                  </li>
               </va-dropdown>

               <span style="font-weight:700;margin:0 40px 0 10px;">
                  VoteMap - MS 2018
               </span>
               <va-desktop>

                  <!-- <va-button size="lg" :class="{current: this.$route.path=='/'}" type="subtle" class="noborder" @click.native="goto()">
                     Home
                  </va-button> -->

                  <va-button size="lg" :class="{current: this.$route.path=='/'}" type="subtle" class="noborder" @click.native="goto('/')">
                     Kuchis
                  </va-button>

                  <va-button size="lg" :class="{current: this.$route.path=='/contacts'}" type="subtle" class="noborder" @click.native="goto('/contacts')">
                     Contacts
                  </va-button>

                  <va-button size="lg" :class="{current: this.$route.path=='/provinces'}" type="subtle" class="noborder" @click.native="goto('/provinces')">
                     Provinces
                  </va-button>

                  <va-button size="lg" :class="{current: this.$route.path=='/about'}" type="subtle" class="noborder" @click.native="goto('/about')">
                     About
                  </va-button>

               </va-desktop>
            </div>
            <div slot="right">
               <!-- <va-input icon="search" style="margin-right:7px;"></va-input> -->
               <va-tooltip :content="user.email" trigger="hover" placement="left">
                  <va-button type="primary-dark" round @click.native="logout">
                     <va-icon type="user" size="1.25em"></va-icon>
                  </va-button>
               </va-tooltip>
            </div>
         </va-topbar>

         <!-- See Topbar documentation -->
         <!-- <va-minibar /> -->
         <!-- See Minibar documentation -->
         <!-- <va-sidebar theme="default" /> -->
         <!-- See Sidebar documentation -->
      </va-bars>
      <va-page size="md" class="md2">
         <!-- See Page documentation -->
         <!-- <div id="nav">
            <router-link to="/">Homeeeee</router-link> |
            <router-link to="/about">About</router-link> |
            <router-link to="/help">Help</router-link>   
         </div> -->
         <router-view/>
      </va-page>

   </va-layout-manager>
</template>

<script>
   import {
      store
   } from "./store";
   export default {
      data() {
         return {};
      },
      methods: {
         goto(to) {
            // console.log(this.$route);
            let url = to || "/";
            this.$router.push(url);
         },
         logout() {
            store.dispatch("logout");
            // asdf
            this.$router.push("/login");
         }
      },
      computed: {
         user() {
            return store.getters.user;
         }
      }
   };
</script>
<style>
   .md2 .va-page-container-md {
      width: 1140px;
      max-width: 1140px;
   }

   .noborder {
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
   }

   .datatable {
      border: 2px solid #07f7;
      border-bottom: none;
   }

   .datatable tbody,
   .datatable tfoot,
   .datatable thead {
      border-bottom: 2px solid #07f7 !important;
   }

   .datatable th {
      color: #026a !important;
      font-size: 0.8em;
      text-transform: uppercase;
      background: #0bf1;
   }

   .va-btn-lg {
      font-size: 14px !important;
      font-weight: 100 !important;
   }

   .va-topbar .va-btn-lg {
      border-radius: 0;
      min-height: 50px;
   }

   .current {
      background-color: #ebecf0 !important;
      color: #505f79 !important;
   }
</style>